import { call, put, all, takeEvery } from "redux-saga/effects";
// Login Redux States
import { USER_PROFILE } from "./actionTypes";
import { getUserProfileSuccess } from "./actions";
import { makeAjax, showMessage, url } from "../../helpers/global_helper";
import i18next from "i18next";

function* getUserProfile({ payload: { formData } }) {
  try {

    const response = yield call(
      makeAjax,
      url.PLAYER_API.getUser, {}, url.PLAYER_MS_EXT);
    if (response.status == 'SUCCESS') {
      yield all([
        put(getUserProfileSuccess(response.data.user))
      ]);
      const theme = response.data.user.tg_theme 
      const lang = response.data.user.lang_id === 102 ? 'en' : 'id';
      localStorage.setItem('theme', theme);
      localStorage.setItem('nickname', response.data.user.nickname);
      localStorage.setItem("I18N_LANGUAGE", lang);
      i18next.changeLanguage(lang);
      
      // if (!response.data.user.nickname && window.location.href != window.location.origin + "/nickname") {
      //   window.location.href = window.location.origin + "/nickname";
      // }
      if (response.data.user.nickname) {
        if (window.location.href === window.location.origin + "/nickname") {
          window.location.href = window.location.origin + "/";
        }
      } else {
        if (window.location.href !== window.location.origin + "/nickname") {
          window.history.pushState({}, "", "/nickname");
          window.dispatchEvent(new Event("popstate"));
        }
      }
    }
    else {
      showMessage(response);
    }
  } catch (error) {

  }
}

function* userProfileSaga() {
  yield takeEvery(USER_PROFILE, getUserProfile);
}
export default userProfileSaga;
